import React from 'react';
import duckify from "../../../utils/duckify";
import {sharedPortalSchoolGroups as groups} from "../../../ducks";
import FormField from "./FormField";


const SchoolGroupField = ({name, label, groups, required}) => {
  const options = groups.map(group => ({label: group.name, value: group.id}));

  return (
    <FormField type="select" label={label} name={name} options={options} colWidth={12} required={required} />
  );
};

const mapDucksToProps = () => ({
  groups
});

export default duckify(mapDucksToProps)(SchoolGroupField);
